import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Wheat, Eye, EyeOff } from 'lucide-react';

export default function LoginCliente() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== 'cliente') {
        navigate('/admin/dashboard');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err.userMessage || 'Erro ao entrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center px-6"
      style={{ backgroundImage: `linear-gradient(rgba(44,30,22,0.7),rgba(131,44,17,0.7)), url('https://images.pexels.com/photos/192933/pexels-photo-192933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')` }}
      data-testid="mobile-login-page"
    >
      <div className="w-full max-w-sm animate-slide-in">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/logo-fatima.jpg" alt="Fátima Guterres" className="w-52 h-auto rounded-2xl mx-auto mb-3 shadow-xl object-cover" />
          <p className="text-white/80 text-sm mt-1 font-body">Faça seu pedido com facilidade</p>
        </div>

        {/* Form card */}
        <div className="bg-white rounded-3xl p-6 shadow-2xl">
          <h2 className="font-dashboard font-bold text-brand-text text-lg mb-5">Entrar na sua conta</h2>
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl px-4 py-3 mb-4" data-testid="login-error">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-brand-text-muted mb-1.5 font-body">
                CNPJ <span className="text-xs text-brand-text-muted/60">(somente números)</span>
              </label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={14}
                className="input-mobile"
                placeholder="00000000000000"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value.replace(/\D/g, '') })}
                required
                autoComplete="username"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-text-muted mb-1.5 font-body">Senha</label>
              <div className="relative">
                <input
                  type={showPwd ? 'text' : 'password'}
                  className="input-mobile pr-12"
                  placeholder="Sua senha"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                  autoComplete="current-password"
                  data-testid="login-password"
                />
                <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-text-muted">
                  {showPwd ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>
            <Link to="/recuperar-senha" className="text-xs text-brand-primary font-medium font-body block text-right">
              Esqueci minha senha
            </Link>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 rounded-full btn-primary font-dashboard font-semibold text-sm disabled:opacity-60"
              data-testid="login-submit"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
          <p className="text-center text-sm text-brand-text-muted mt-5 font-body">
            Primeiro acesso?{' '}
            <Link to="/cadastro" className="text-brand-primary font-semibold" data-testid="register-link">
              Criar conta
            </Link>
          </p>
        </div>

        <p className="text-center text-xs text-white opacity-60 mt-6 font-body">
          Acesso administrativo?{' '}
          <Link to="/admin/login" className="underline opacity-80">Dashboard</Link>
        </p>
      </div>
    </div>
  );
}
